webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(16);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.vm = new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(9)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(4),
	  /* template */
	  __webpack_require__(19),
	  /* scopeId */
	  "data-v-4d1f3b45",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(8)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(7),
	  /* template */
	  __webpack_require__(18),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello',
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App'
	    };
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var Hello, Instrument, LineC;
	
	Hello = __webpack_require__(2);
	
	LineC = __webpack_require__(3);
	
	Instrument = __webpack_require__(17);
	
	module.exports = {
	  name: 'app',
	  components: {
	    Hello: Hello,
	    LineC: LineC,
	    Instrument: Instrument
	  },
	  data: function() {
	    return {
	      time: -1,
	      res: 16,
	      isPlaying: false,
	      instruments: 1,
	      bpm: 80,
	      globalTranspose: 0
	    };
	  },
	  methods: {
	    nextTick: function() {
	      var self, timeBetweenBeats;
	      if (!this.isPlaying) {
	        this.time = -1;
	        return;
	      }
	      timeBetweenBeats = (60 * 1000) / (this.bpm * this.res);
	      this.time = this.time + 1;
	      self = this;
	      return setTimeout(function() {
	        return self.nextTick();
	      }, timeBetweenBeats);
	    },
	    togglePlay: function() {
	      if (this.time === -1) {
	        this.isPlaying = true;
	        return this.nextTick();
	      } else {
	        this.time === -1;
	        return this.isPlaying = false;
	      }
	    }
	  }
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var Hello, LineC, Tone,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	Hello = __webpack_require__(2);
	
	LineC = __webpack_require__(3);
	
	Tone = __webpack_require__(15);
	
	module.exports = {
	  name: 'instrument',
	  components: {
	    Hello: Hello,
	    LineC: LineC
	  },
	  props: ['time', 'res', 'globalTranspose'],
	  data: function() {
	    return {
	      notes: {
	        "C5": [],
	        "B4": [],
	        "A4": [],
	        "G4": [],
	        "F4": [],
	        "E4": [],
	        "D4": [],
	        "C4": []
	      },
	      steps: 16,
	      measures: 4,
	      synth: "sine",
	      transpose: 0,
	      filterCutoff: 3000,
	      volume: 50,
	      attack: 0.01,
	      decay: 2.0
	    };
	  },
	  computed: {
	    currentStep: function() {
	      var ticksPerStep;
	      ticksPerStep = this.measures * this.res / this.steps;
	      return Math.floor(this.time / ticksPerStep) % this.steps;
	    },
	    computedTranspose: function() {
	      return this.transpose + this.globalTranspose;
	    }
	  },
	  watch: {
	    currentStep: function() {
	      return this.playNextStep();
	    },
	    steps: function() {
	      var key, results;
	      results = [];
	      for (key in this.notes) {
	        results.push(this.notes[key] = []);
	      }
	      return results;
	    },
	    synth: function(val) {
	      this.player.set({
	        oscillator: {
	          type: val
	        }
	      });
	      Tone.context.resume();
	      return this.player.triggerAttackRelease("C4", "8n", "+0", this.volume / 100);
	    },
	    computedTranspose: function(val) {
	      if (isNaN(val)) {
	        val = 0;
	      }
	      return this.player.set({
	        oscillator: {
	          detune: val * 100
	        }
	      });
	    },
	    filterCutoff: function(val) {
	      if (!isNaN(parseInt(val)) && parseInt(val) > 0) {
	        return this.filter.set({
	          frequency: val
	        });
	      }
	    },
	    volume: function(val) {
	      if (!isNaN(parseInt(val))) {
	        return this.player.set({
	          volume: val / 100
	        });
	      }
	    },
	    attack: function(val) {
	      if (!isNaN(parseInt(val))) {
	        return this.player.set({
	          envelope: {
	            attack: val
	          }
	        });
	      }
	    },
	    decay: function(val) {
	      if (!isNaN(parseInt(val))) {
	        return this.player.set({
	          envelope: {
	            decay: val,
	            release: val
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    playNextStep: function() {
	      var onNotes, pitch, ref, ref1, results, self;
	      self = this;
	      ref = this.notes;
	      results = [];
	      for (pitch in ref) {
	        onNotes = ref[pitch];
	        if ((ref1 = this.currentStep, indexOf.call(onNotes, ref1) >= 0)) {
	          Tone.context.resume();
	          results.push(this.player.triggerAttackRelease(pitch, "8n", "+0", this.volume / 100));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    handleToggleBox: function(pitch, pos) {
	      var index;
	      if (indexOf.call(this.notes[pitch], pos) >= 0) {
	        index = this.notes[pitch].indexOf(pos);
	        if (index !== -1) {
	          return this.notes[pitch].splice(index, 1);
	        }
	      } else {
	        this.notes[pitch].push(pos);
	        Tone.context.resume();
	        return this.player.triggerAttackRelease(pitch, "8n", "+0", this.volume / 100);
	      }
	    }
	  },
	  created: function() {
	    var defaultEnv, synth;
	    synth = new Tone.PolySynth(4, Tone.OmniSynth);
	    synth.set({
	      "oscillator": {
	        "type": this.synth,
	        detune: this.transpose * 100
	      }
	    });
	    defaultEnv = {
	      "envelope": {
	        "attack": this.attack,
	        "decay": this.decay,
	        "sustain": 0.0,
	        "release": this.decay
	      }
	    };
	    synth.set(defaultEnv);
	    this.filter = new Tone.Filter(this.filterCutoff, "lowpass");
	    this.synthPlayer = synth;
	    synth.connect(this.filter);
	    this.filter.connect(Tone.Master);
	    this.player = synth;
	    this.player.set({
	      volume: this.volume / 100
	    });
	    return this.player.set({
	      oscillator: {
	        detune: this.computedTranspose * 100
	      }
	    });
	  }
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = {
	  name: 'line',
	  props: ['beats', 'currentNote', 'onNotes', 'pitch'],
	  computed: {
	    beatsArray: function() {
	      var i, it, len, onNote, ref;
	      it = new Array(this.beats);
	      ref = this.onNotes;
	      for (i = 0, len = ref.length; i < len; i++) {
	        onNote = ref[i];
	        if (onNote < this.beats) {
	          it[onNote] = true;
	        }
	      }
	      return it;
	    }
	  },
	  methods: {
	    handleClick: function(index) {
	      return this.$emit('toggle-box', this.pitch, index);
	    }
	  }
	};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(11)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(21),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(10)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(6),
	  /* template */
	  __webpack_require__(20),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-container"
	  }, _vm._l((_vm.beatsArray), function(elem, index) {
	    return _c('div', {
	      staticClass: "box",
	      class: {
	        active: elem, played: index == _vm.currentNote
	      },
	      on: {
	        "click": function($event) {
	          _vm.handleClick(index)
	        }
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hello"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org",
	      "target": "_blank"
	    }
	  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://forum.vuejs.org",
	      "target": "_blank"
	    }
	  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://gitter.im/vuejs/vue",
	      "target": "_blank"
	    }
	  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://twitter.com/vuejs",
	      "target": "_blank"
	    }
	  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vuejs-templates.github.io/webpack/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Docs for This Template")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "http://router.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vuex.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vue-loader.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/vuejs/awesome-vue",
	      "target": "_blank"
	    }
	  }, [_vm._v("awesome-vue")])])])
	}]}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "instrument"
	  }, [_c('div', {
	    staticClass: "controls"
	  }, [_c('div', [_c('label', [_vm._v("Steps: ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.steps),
	      expression: "steps",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.steps)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.steps = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Measures: ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.measures),
	      expression: "measures",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.measures)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.measures = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Transpose (semitones): ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.transpose),
	      expression: "transpose",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.transpose)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.transpose = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Velocity (%): ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.volume),
	      expression: "volume",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.volume)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.volume = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Synth type: ")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.synth),
	      expression: "synth"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.synth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "disabled"
	    }
	  }), _c('option', [_vm._v("sine")]), _c('option', [_vm._v("sawtooth")]), _c('option', [_vm._v("square")]), _c('option', [_vm._v("triangle")]), _c('option', {
	    attrs: {
	      "disabled": "disabled"
	    }
	  }), _c('option', [_vm._v("sine4")]), _c('option', [_vm._v("sawtooth4")]), _c('option', [_vm._v("square4")]), _c('option', [_vm._v("triangle4")]), _c('option', {
	    attrs: {
	      "disabled": "disabled"
	    }
	  }), _c('option', [_vm._v("fmsine")]), _c('option', [_vm._v("fmsawtooth")]), _c('option', [_vm._v("fmsquare")]), _c('option', [_vm._v("fmtriangle")]), _c('option', {
	    attrs: {
	      "disabled": "disabled"
	    }
	  }), _c('option', [_vm._v("fatsine")]), _c('option', [_vm._v("fatsawtooth")]), _c('option', [_vm._v("fatsquare")]), _c('option', [_vm._v("fattriangle")])])]), _c('div', [_c('label', [_vm._v("Attack (seconds): ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.attack),
	      expression: "attack",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.attack)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.attack = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Decay (seconds): ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.decay),
	      expression: "decay",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.decay)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.decay = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Filter cutoff (hz): ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.filterCutoff),
	      expression: "filterCutoff",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.filterCutoff)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filterCutoff = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "boxes"
	  }, _vm._l((_vm.notes), function(onNotes, pitch) {
	    return _c('line-c', {
	      attrs: {
	        "beats": _vm.steps,
	        "current-note": _vm.currentStep,
	        "pitch": pitch,
	        "on-notes": onNotes
	      },
	      on: {
	        "toggle-box": _vm.handleToggleBox
	      }
	    })
	  }))]), _c('hr')])
	},staticRenderFns: []}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('h1', [_vm._v("Music is fun")]), _c('button', {
	    on: {
	      "click": _vm.togglePlay
	    }
	  }, [_vm._v("Play / Stop")]), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.instruments++
	      }
	    }
	  }, [_vm._v("Add Instrument")]), _c('label', [_vm._v("BPM: ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.bpm),
	      expression: "bpm",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.bpm)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.bpm = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _c('label', [_vm._v("Min step resolution:")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.res),
	      expression: "res",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.res)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.res = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _c('label', [_vm._v("Global transpose:")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.globalTranspose),
	      expression: "globalTranspose",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.globalTranspose)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.globalTranspose = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _c('hr'), _vm._l((_vm.instruments), function(i) {
	    return _c('instrument', {
	      attrs: {
	        "res": _vm.res,
	        "time": _vm.time,
	        "globalTranspose": _vm.globalTranspose
	      }
	    })
	  }), _c('a', {
	    attrs: {
	      "href": "https://github.com/bsteephenson/Step-Sequencer"
	    }
	  }, [_vm._v("Source")])], 2)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.dcd8cca8bf953e4db03b.js